import React from "react"

import { FeatureContainer, Image, Divider, MiddleContainer, Value, Label } from "./styles"

const FeatureHighlight = ({ cloudinaryUrl, value, label }) => (
  <FeatureContainer imgPresent={!!cloudinaryUrl}>
    {cloudinaryUrl && (
      <Image
        baseUrl={cloudinaryUrl}
        images={[{ transforms: "c_fit,w_62,h_62,q_90,f_auto,fl_lossy" }]}
      />
    )}
    <MiddleContainer>{label ? <Label>{label}</Label> : <Divider />}</MiddleContainer>
    <Value>{value}</Value>
  </FeatureContainer>
)

export default FeatureHighlight
